import { Route, Switch } from "react-router";

import PageTitle from "../../ui/PageTitle/PageTitle";

import { ROUTES } from "../../module/constants";
import {
  DELEGATION_MANAGEMENT_URLS,
  IDelegationManagementProps,
} from "./module/constants";

import DelegationManagementStepOne from "./DelegationManagementStepOne/DelegationManagementStepOne";
import DelegationManagementStepTwo from "./DelegationManagementStepTwo/DelegationManagementStepTwo";
import DelegationManagementStepThree from "./DelegationManagementStepThree/DelegationManagementStepThree";

import { resetDelegationState } from "./module/actions";

import messages from "./module/messages";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

const DelegationManagement = (props: IDelegationManagementProps) => {
  return (
    <>
      <PageTitle title={messages.pageTitle} />
      <Switch>
        <Route
          strict
          exact
          path={ROUTES.DELEGATES}
          component={DelegationManagementStepOne}
        />
        <Route
          path={DELEGATION_MANAGEMENT_URLS.ADD_DELEGATION}
          component={DelegationManagementStepTwo}
        />
        <Route
          path={DELEGATION_MANAGEMENT_URLS.USER_CHOICE}
          component={DelegationManagementStepThree}
        />
      </Switch>
    </>
  );
};

const mapStateToProps: any = () => createStructuredSelector({});

const mapDispatchToProps: any = {
  resetDelegationState: () => resetDelegationState(),
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(DelegationManagement);
